import * as React from 'react';
// import CallbackListener from "./callbackListener.tsx";

type Props = Readonly<{
	isPreview?: boolean,
}>

function DocumentBodyFooter({isPreview = false}: Props) {
	return (<>
		{/*<CallbackListener/>*/}
	</>);
}

export default DocumentBodyFooter;
